<template>
    <b-modal
        title="Detalhes do alerta"
        :visible="isVisible"
        centered
        header-bg-variant="secondary"
        header-text-variant="light"
        footer-bg-variant="light"
        ok-variant="secondary"
        ok-title="Fechar"
        ok-only
        no-fade
        @hidden="onHidden"
    >
        <b-form id="alert-details" novalidate>
            <b-form-group
                label="Data de emissão"
                label-for="alert-details-alert-datetime"
            >
                <b-form-input
                    id="alert-details-alert-datetime"
                    v-model="item.epoch"
                    type="text"
                    disabled
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Nível">
                <b-badge
                    :variant="alertLevelInfo.variant"
                    class="d-block p-2"
                    >{{ alertLevelInfo.text }}</b-badge
                >
            </b-form-group>
            <b-form-group label="Tipo" label-for="alert-details-alert-type">
                <b-form-input
                    id="alert-details-alert-type"
                    v-model="alertType"
                    type="text"
                    disabled
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Título" label-for="alert-details-alert-title">
                <b-form-input
                    id="alert-details-alert-title"
                    v-model="item.title"
                    type="text"
                    disabled
                ></b-form-input>
            </b-form-group>
            <b-form-group
                label="Descrição"
                label-for="alert-details-alert-description"
            >
                <b-form-textarea
                    id="alert-details-alert-description"
                    v-model="item.description"
                    type="text"
                    rows="10"
                    max-rows="15"
                    disabled
                ></b-form-textarea>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import moment from "moment";
import { AlertLevels, AlertTypes } from "@/modules/common/settings";

export default {
    name: "AlertDetails",
    computed: {
        item() {
            if (this.isVisible) {
                return {
                    ...this.$store.state.common.alerts.itemDetails,
                    epoch: moment(
                        this.$store.state.common.alerts.itemDetails.epoch
                    ).format("DD/MM/YYYY HH:mm:ss")
                };
            }
            return {
                id: -1
            };
        },
        isVisible() {
            return !!this.$store.state.common.alerts.itemDetails;
        },
        alertLevelInfo() {
            const { alert_level: alertLevel } = this.item;
            const isCritical = alertLevel === AlertLevels.CRITICAL;
            const isWarning = alertLevel === AlertLevels.WARNING;
            let variant = "info";
            let text = "INFORMAÇÃO";

            if (isCritical) {
                variant = "danger";
                text = "CRÍTICO";
            }

            if (isWarning) {
                variant = "warning";
                text = "AVISO";
            }

            return { variant, text };
        },
        alertType() {
            if (this.item.alert_type === AlertTypes.RTS) {
                return "RTS";
            }
            return "Reservatório";
        }
    },
    methods: {
        onHidden() {
            this.$store.dispatch("common/alerts/setItemDetails", null);
        }
    }
};
</script>
